import { useMutation, useQuery } from "@apollo/client";
import { Button, Flex, Grid, List, Paper, Space, Text, Title } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from '@mantine/hooks';
import { CURRENT_USER } from "../../queries/auth";
import { GET_ALL_CONTESTS, GET_LEADERBOARD } from "../../queries/contest";
import { ADD_LOG } from "../../queries/user-analytics";
import { logPageView} from "../../helpers/useGA"

import LeaderboardCard from "../../components/assets/LeaderboardCard/LeaderboardCard";
import ContestDetailedCard from "../../components/assets/ContestDetailedCard/ContestDetailedCard";
import ContestCard from "../../components/assets/ContestCard/ContestCard";
import PaginationBar from "../../components/assets/PaginationBar/PaginationBar";
import SearchBar from "../../components/common/SearchBar/SearchBar";

import "./ContestPage.css";

export default function ContestPage() {
    const [upcomingContests, setUpcomingContests] = useState([]);
    const [ongoingContest, setOngoingContests] = useState([]);
    const [pastContests, setPastContests] = useState([]);
    const [rankings, setRankings] = useState([]);
    const [activeTab, setActiveTab] = useState('ongoing');
    const location = useLocation();

    const [currentLeaderboardPage, setLeaderboardPage] = useState(0);
    const [firstRankingIndex, setFirstRankingIndex] = useState(0);
    const [currentContestsPage, setContestsPage] = useState(0);
    const [firstContestIndex, setFirstContestIndex] = useState(2);

    // const [update, setUpdate] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const { loading, error, data } = useQuery(CURRENT_USER);
    const [userid, setUserid] = useState(null);
    const { loading: contestQueryloading, error: contestQueryError, data: contestQueryData } = useQuery(GET_ALL_CONTESTS);
    const { loading: leaderboardQueryloading, error: leaderboardQueryError, data: leaderboardQueryData, refetch } = useQuery(GET_LEADERBOARD);

    // added for tracking user data
    const [logEventMutation] = useMutation(ADD_LOG, {
        onCompleted: ({ addLog }) => {
            // Access the HTTP response directly
            const { status, message } = logEvent;
            if (status === "success") {
                console.log("Event logged successfully:", message);
            } else {
                console.error("Failed to log event:", message);
            }
        },
        onError: (error) => {
            console.error("Error logging event:", error.message);
        }
    });

    const logEvent = (eventType, additionalData, _userid) => {
        const eventData = {
            userid: Number(_userid),
            event_type: eventType,
            timestamp: new Date().toISOString(),
            additional_data: JSON.stringify(additionalData)

        };

        logEventMutation({ variables: eventData });
    };
    useEffect(() => {
        if (loading) console.log('Loading user...')
        else if (error) { setUserid(null) }
        else {
          setUserid(data.currentUser.userid);
          logEvent ('ContestPage', data.currentUser ,data.currentUser.userid);
          const pageTitle = "Contest Page";
          document.title = pageTitle; // Update document title
          logPageView(location.pathname + location.search, pageTitle);
        }
    }, [loading, error, data, location.pathname, location.search])
   
    useEffect(() => {
        if (contestQueryloading) { }
        else if (contestQueryError) console.log(contestQueryError);
        else {
            const pastContests = [];
            const ongoingContests = [];
            const upcomingContests = [];
            for (const contest of contestQueryData.getAllContests) {
                // Convert PostgreSQL timestamps to JavaScript Date objects
                const contestStartTime = new Date(contest.startat).getTime();
                const contestEndTime = new Date(contest.endat).getTime();
                const currentTime = Date.now();
                
                console.log(`Contest: ${contest.name}`);
                console.log(`  Start Raw: ${contest.startat}`);
                console.log(`  End Raw: ${contest.endat}`);
                console.log(`  Start Time: ${contestStartTime} (${new Date(contestStartTime)})`);
                console.log(`  End Time: ${contestEndTime} (${new Date(contestEndTime)})`);
                console.log(`  Current Time: ${currentTime} (${new Date(currentTime)})`);
                
                if (contestEndTime <= currentTime) {
                    pastContests[pastContests.length] = contest;
                    console.log("Past Contest: " + contest.name)
                } else {
                    if (contestStartTime <= currentTime) {
                        ongoingContests[ongoingContests.length] = contest;
                        console.log("Ongoing Contest: " + contest.name)
                    } else {
                        upcomingContests[upcomingContests.length] = contest;
                        console.log("Upcoming Contest: " + contest.name)
                    }
                }
            }
            setOngoingContests(ongoingContests);
            setPastContests(pastContests);
            setUpcomingContests(upcomingContests);
        }
    }, [contestQueryloading, contestQueryError, contestQueryData]);

    useEffect(() => {
        if (leaderboardQueryloading) { }
        else if (leaderboardQueryError) console.log(leaderboardQueryError)
        else {
            setRankings(leaderboardQueryData.getLeaderboard.map((ranking, index) => [index + 1, ranking]));

            // Set up the interval to update every minute
            const intervalId = setInterval(refetch, 60000);

            // Clean up the interval on unmount
            return () => clearInterval(intervalId);
        }
    }, [leaderboardQueryloading, leaderboardQueryError, leaderboardQueryData, refetch]);

    // setInterval(() => {
    //     setUpdate(!update);
    // }, 60000);

    const rankingsPerPage = 7;
    const contestsPerPage = 5;

    let filteredRankings = rankings.filter((ranking) => 
        ranking[1].alias.toLowerCase().includes(searchQuery.toLowerCase())
    );
    let leaderboardPageCount = Math.ceil(filteredRankings.length / rankingsPerPage);

    const changeLeaderboardPage = (pageNumber) => {
        if (pageNumber !== currentLeaderboardPage) {
            setLeaderboardPage(pageNumber);
            setFirstRankingIndex(pageNumber * rankingsPerPage);
        }
    }

    const changeContestsPage = (pageNumber) => {
        if (pageNumber !== currentContestsPage) {
            setContestsPage(pageNumber);
            if (activeTab === 'past') {
                setFirstContestIndex(pageNumber * contestsPerPage);
            } else if (activeTab === 'upcoming') {
                setFirstContestIndex(pageNumber * contestsPerPage);
            } else if (activeTab === 'ongoing') {
                setFirstContestIndex(pageNumber * contestsPerPage);
            }
        }
    }

    const handleSearch = (value) => {
        setSearchQuery(value);
        setLeaderboardPage(0);
        setFirstRankingIndex(0);
    };

    const isMobile = useMediaQuery('(max-width: 1090px)');

    return (
        <Grid gutter="xl">
            {!isMobile && <Grid.Col span={7}>
                <Title order={2}>NUSwap Contest</Title>
                <Space h="xs" />
                <Text>Contest every week, compete and see your ranking!</Text>
                <Grid my="md" grow gutter="lg">
                    <Grid.Col span={6}>
                        { pastContests.length > 1 ? <ContestDetailedCard contest={pastContests[1]}/> : null} 
                    </Grid.Col>
                    <Grid.Col span={6}>
                        { pastContests.length > 0 ? <ContestDetailedCard contest={pastContests[0]}/> : null}
                    </Grid.Col>
                </Grid>
                <Paper shadow="sm" radius="md" withBorder pt="md" pb="xs">
                    <Flex gap="md" mb="md" ml="xl" justify="center" wrap="wrap">
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('ongoing')} disabled={activeTab === 'ongoing'}>Ongoing Contests</Button>
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('upcoming')} disabled={activeTab === 'upcoming'}>Upcoming Contests</Button>
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('past')} disabled={activeTab === 'past'}>Past Contests</Button>
                    </Flex>
                    
                    <List size="xl" center>
                    {activeTab === 'past'
                        ? pastContests
                            .slice(firstContestIndex, firstContestIndex + contestsPerPage)
                            .map((contest, index) => <ContestCard contest={contest} key={index} />)
                        : activeTab === 'ongoing' ? ongoingContest.map((contest, index) => <ContestCard contest={contest} key={index} />) :
                        upcomingContests
                            .map((contest, index) => <ContestCard contest={contest} key={index} />)
                    }
                    </List>
                </Paper>
                
                <PaginationBar currentPage={currentContestsPage} pageCount={activeTab === 'past' ? Math.ceil(pastContests.length / contestsPerPage) : Math.ceil(upcomingContests.length / contestsPerPage)} handleOnClick={changeContestsPage}/>
            </Grid.Col>}
            {isMobile && <Grid.Col span={12}>
                <Title order={1}>NUSwap Contest</Title>
                <Space h="xs" />
                <Text>Contest every week, compete and see your ranking!</Text>
                <Grid my="md" grow gutter="lg">
                    <Grid.Col span={6}>
                        { pastContests.length > 1 ? <ContestDetailedCard contest={pastContests[1]}/> : null} 
                    </Grid.Col>
                    <Grid.Col span={6}>
                        { pastContests.length > 0 ? <ContestDetailedCard contest={pastContests[0]}/> : null}
                    </Grid.Col>
                </Grid>
                <Paper shadow="sm" radius="md" withBorder pt="md" pb="xs">
                    <Flex gap="md" mb="md" ml="xl" justify="center" wrap="wrap">
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('ongoing')} disabled={activeTab === 'ongoing'}>Ongoing Contests</Button>
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('upcoming')} disabled={activeTab === 'upcoming'}>Upcoming Contests</Button>
                        <Button variant="subtle" color="gray" onClick={() => setActiveTab('past')} disabled={activeTab === 'past'}>Past Contests</Button>
                    </Flex>
                    
                    <List size="xl" center>
                    {activeTab === 'past'
                        ? pastContests
                            .slice(firstContestIndex, firstContestIndex + contestsPerPage)
                            .map((contest, index) => <ContestCard contest={contest} key={index} />)
                        : activeTab === 'ongoing' ? ongoingContest.map((contest, index) => <ContestCard contest={contest} key={index} />) :
                        upcomingContests
                            .map((contest, index) => <ContestCard contest={contest} key={index} />)
                    }
                    </List>
                </Paper>
                
                <PaginationBar currentPage={currentContestsPage} pageCount={activeTab === 'past' ? Math.ceil(pastContests.length / contestsPerPage) : Math.ceil(upcomingContests.length / contestsPerPage)} handleOnClick={changeContestsPage}/>
            </Grid.Col>}
            {!isMobile && <Grid.Col span={5}>
                <Paper shadow="sm" radius="md" withBorder pt="md" pb="xs" mx="sm">
                    <Title pl="lg" pb="md" order={2}>Global Ranking</Title>
                    <div className="search-bar-container">
                        <SearchBar 
                            onSearch={handleSearch}
                            placeholder="Search for user..."
                            className="mb-md"
                            debounceDelay={300}
                        />
                    </div>
                    <List size="xl" center>
                        {filteredRankings
                            .slice(firstRankingIndex, firstRankingIndex + rankingsPerPage)
                            .map((ranking, index) =>
                            <LeaderboardCard user={ranking[1]} rank={ranking[0]} key={index} currUser={ranking[1].userid === userid} />
                        )}
                    </List>
                </Paper>

                <PaginationBar currentPage={currentLeaderboardPage} pageCount={leaderboardPageCount} handleOnClick={changeLeaderboardPage}/>
            </Grid.Col>}
            {isMobile && <Grid.Col span={12}>
                <Paper shadow="sm" radius="md" withBorder pt="md" pb="xs" mx="sm">
                    <Title px="xl" pb="md" order={2}>Global Ranking</Title>
                    <div className="search-bar-container">
                        <SearchBar 
                            onSearch={handleSearch}
                            placeholder="Search for user..."
                            className="mb-md"
                            debounceDelay={300}
                        />
                    </div>
                    <List size="xl" center>
                        {filteredRankings
                            .slice(firstRankingIndex, firstRankingIndex + rankingsPerPage)
                            .map((ranking, index) =>
                            <LeaderboardCard user={ranking[1]} rank={ranking[0]} key={index} currUser={ranking[1].userid === userid} />
                        )}
                    </List>
                </Paper>

                <PaginationBar currentPage={currentLeaderboardPage} pageCount={leaderboardPageCount} handleOnClick={changeLeaderboardPage}/>
            </Grid.Col>}
            <Grid.Col span="auto"></Grid.Col>
        </Grid>
    )
}
